export var CATALOG_PAGE_ENDPOINTS = {
  checkHouseConnection: '/api/home/check-connection/house-info/',
  getTariffsByColor: '/customers/products/home/request/getTariffsByColor/',
  fetchAddress: '/api/home/check-connection/get-address/',
  request_low_speed_tariffs: '/hometariffsapi/getlowspeedtariffs/',
  fetchApiTexts: '/api/texts/'
};
export var CONTENT_KEYS = ['fttb-check-address-one-field-enabled', 'fttb-personal-verification-checkbox-enable'];